import { getTenantsData, searchTenantData } from "@/Api/tenants";
import { RegisterBtn } from "@/App/Tenants/Add";
import { SearchComponent } from "@/App/Tenants/Search";
import { CreateLoaderTable } from "@/components/Loaders";
import { Main } from "@/components/Main";
import { ComponentTable } from "@/App/Tenants/Table";
import { useEffect, useState } from "react";
import { useContextData } from "@/components/Context";
import { usePanelUser } from "@/hooks/auth";
import { Building } from "lucide-react";
import { PageHeader } from "@/components/PageHeader";

export type ApiDataProps<T> = {
  data: T[];
  current_page: number;
  last_page: number;
  next_page_url: string | null;
  total_amount?: string;
  total?: number;
  total_sales?: number;
  total_count?: number;
  middle_ticket?: number;
};

export type ApiDataPropsNoPaginate<T> = {
  response: T[];
};

export type TypeTenantsProps = {
  id: number;
  uuid: string;
  name: string;
  email: string;
  phone: string;
  logo: null | string;
  is_active: number;
  created_at: string;
  update_at?: string;
  document?: string;
};

export const Companies = () => {
  const [tenantsData, setTenantsData] = useState(
    {} as ApiDataProps<TypeTenantsProps>
  );
  const [state, setState] = useState("loading");
  const { setData, data } = useContextData();
  const auth = usePanelUser();

  // inicio: pegando dados da api e setando em variavel de estado
  useEffect(() => {
    (async () => {
      const { data: apiResponse } = await getTenantsData();
      setTenantsData(apiResponse?.response);
      setState("production");
      return;
    })();
  }, []);
  useEffect(() => {
    if (tenantsData && tenantsData !== data.tenants.value)
      setData((prev) => {
        return {
          ...prev,
          tenants: { value: tenantsData, setValue: setTenantsData },
        };
      });
  }, [tenantsData]);

  const pageActions = {
    next: async () => {
      if (tenantsData?.current_page < tenantsData?.last_page) {
        setState("loading");

        const { data } = await getTenantsData(tenantsData?.current_page + 1);
        setTenantsData(data.response);
        setState("production");
      }
      return;
    },
    previous: async () => {
      if (tenantsData?.current_page > 1) {
        setState("loading");

        const { data } = await getTenantsData(tenantsData?.current_page - 1);
        setTenantsData(data.response);
        setState("production");
      }
      return;
    },
    lastPage: async () => {
      if (tenantsData?.current_page !== tenantsData?.last_page) {
        setState("loading");

        const { data } = await getTenantsData(tenantsData?.last_page);
        setTenantsData(data.response);
        setState("production");
      }
      return;
    },
  };
  return auth(() => (
    <Main>
      <PageHeader
        icon={Building}
        title="Instituicoes"
        description="Gerencie as instituicoes cadastradas"
      >
        <RegisterBtn setTenantsData={setTenantsData} />
      </PageHeader>
      <div className="flex flex-col gap-3">
        <SearchComponent
          updateFront={(response) => setTenantsData(response)}
          setState={setState}
          funcSearch={searchTenantData}
        />
        {state === "loading" ? (
          <CreateLoaderTable cols={4} lines={6} />
        ) : (
          <ComponentTable
            dataApi={tenantsData}
            updateFront={setTenantsData}
            pageActions={pageActions}
          />
        )}
      </div>
    </Main>
  ));
};
